<template>
    <div class="attr-content">
        <ColorProp v-if="prop.type.name==='color'" v-model="config.props[prop.name]" v-bind="options" @save="save"></ColorProp>
        <AxisDataProp v-else-if="prop.type.name==='axis-data'" v-model="config.props[prop.name]" v-bind="options" @save="save"></AxisDataProp>
        <ImageProp v-else-if="prop.type.name==='image'" v-model="config.props[prop.name]" v-bind="options" @save="save"></ImageProp>
        <SeriesDataProp v-else-if="prop.type.name==='series-data'" v-model="config.props[prop.name]" v-bind="options" @save="save"></SeriesDataProp>
        <DataJsonProp v-else-if="prop.type.name==='data-json'" v-model="config.props[prop.name]" v-bind="options" @save="save"></DataJsonProp>
        <DataRestProp v-else-if="prop.type.name==='data-rest'" v-model="config.props[prop.name]" v-bind="options" @save="save"
        :isDefault="!!config.props[prop.name][config.id]" :allFunctionsMap="allFunctionsMap"></DataRestProp>
        <PercentProp v-else-if="prop.type.name==='percent'" v-model="config.props[prop.name]" v-bind="options" @save="save"></PercentProp>
        <FontProp v-else-if="prop.type.name==='font'" v-model="config.props[prop.name]" v-bind="options" @save="save"></FontProp>
        <TextProp v-else-if="prop.type.name==='text'" v-model="config.props[prop.name]" v-bind="options" @save="save"></TextProp>
        <SeriesColor v-else-if="prop.type.name==='series-color'" v-model="config.props[prop.name]" v-bind="options" @save="save"></SeriesColor>
        <NumberProp v-else-if="prop.type.name==='number'" v-model="config.props[prop.name]" v-bind="options" @save="save"></NumberProp>
        <RankProp v-else-if="prop.type.name==='rank'" v-model="config.props[prop.name]" v-bind="options" @save="save"></RankProp>
        <SelectProp v-else-if="prop.type.name==='select'" v-model="config.props[prop.name]" v-bind="options" @save="save"></SelectProp>
        <SelectProp1 v-else-if="prop.type.name==='select1'" v-model="config.props[prop.name]" v-bind="options" @save="save"></SelectProp1>
        <radioProp v-else-if="prop.type.name==='radio'" v-model="config.props[prop.name]" v-bind="options" @save="save"></radioProp>
        <NumberUnitProp v-else-if="prop.type.name==='number-unit'" v-model="config.props[prop.name]" v-bind="options" @save="save"></NumberUnitProp>
        <BoolProp v-else-if="prop.type.name==='bool'" v-model="config.props[prop.name]" v-bind="options" @save="save"></BoolProp>
        <ObjectProp v-else-if="prop.type.name==='literal'" v-model="config.props[prop.name]" v-bind="options" @save="save"></ObjectProp>
        <SliderProp v-else-if="prop.type.name==='slider'" v-model="config.props[prop.name]" v-bind="options" @save="save"></SliderProp>
        <SwitchProp v-else-if="prop.type.name==='switch'" v-model="config.props[prop.name]" v-bind="options" @save="save"></SwitchProp>
        <MapSymbolProp v-else-if="prop.type.name==='map-symbol'" v-model="config.props[prop.name]" v-bind="options" @save="save"></MapSymbolProp>
        <MapPolygonSelect v-else-if="prop.type.name==='map-polygon-select'" v-model="config.props[prop.name]" v-bind="options" @save="save" @updateVal="updateVal"></MapPolygonSelect>
        <DatasetProp v-else-if="prop.type.name==='dataset'" v-model="config.props[prop.name]" :metadata="prop" v-bind="options" @save="save"></DatasetProp>
    </div>
</template>
<script>
import ColorProp from './color-prop.vue';
import AxisDataProp from './axis-data-prop.vue'
import SeriesDataProp from './chart-prop/series-data-prop.vue'
import DataJsonProp from './data-prop/data-json-prop.vue';
import DataRestProp from './data-prop/data-rest-prop.vue';
import PercentProp from './percent-prop';
import FontProp from './font-prop.vue';
import TextProp from './text-prop.vue';
import SeriesColor from './series-color.vue';
import NumberProp from './number-prop.vue';
import NumberUnitProp from './number-unit-prop';
import RankProp from './rank-prop';
import SelectProp1 from './select';
import SelectProp from './select-prop';
import radioProp from './radio-prop';
import ImageProp from './image-prop';
import BoolProp from './bool-prop';
import ObjectProp from './object-prop';
import SliderProp from './slider-prop';
import SwitchProp from './switch-prop';
import MapSymbolProp from './map-symbol-prop';
import MapPolygonSelect from './map-polygon-select';
import DatasetProp from './data-prop/dataset-prop';
export default {
    props:["prop","config","metadata","allFunctionsMap"],
    components:{
        ColorProp, 
        AxisDataProp, 
        DataJsonProp,
        DataRestProp,
        PercentProp,
        ColorProp, 
        AxisDataProp, 
        FontProp, 
        TextProp,
        SeriesColor,
        NumberProp,
        RankProp,
        SelectProp,
        radioProp,
        NumberUnitProp,
        SelectProp1,
        SeriesDataProp,
        ImageProp,
        BoolProp,
        ObjectProp,
        SliderProp,
        SwitchProp,
        MapSymbolProp,
        DatasetProp,
        MapPolygonSelect
    },
    data() {
        return {
        }
    },
    computed:{
        options(){
            if(this.prop&&this.prop.type&&this.prop.type.options){
                let orgin = JSON.parse(JSON.stringify(this.prop.type.options));
                this.replaceVariables(orgin);
                return orgin;
            }
            return {};
        }
    },
    methods: {
        save(){
            this.$emit("save");
        },
        updateVal(val){
            this.$emit("updateVal",val);
        },
        replaceVariables(orgin){
            for (const key in orgin) {
                if (orgin.hasOwnProperty(key)) {
                    const val = orgin[key];
                    if(val&&(typeof val === 'string')&&val.indexOf('@')===0){
                        orgin[key] = this.config.props[val.substring(1)]
                    }
                }
            }
        }
    },
}
</script>